import React from "react";
import InstallerContent from "../Components/InstallerContent";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";

const Installer = () => {
    const seoData = getSEOData("/installer");

    return (
        <>
            <SEO
                title={seoData.title}
                description={seoData.description}
                keywords={seoData.keywords}
                type="website"
            />
            < InstallerContent />
        </>
    );
};

export default Installer;